import React from 'react';
import { useTranslation } from 'react-i18next';
import { resolveValidationMessage } from 'helpers/validationMessages';

// The legacy (v1 CgForm) field-error renderer, and the second of exactly two
// places that resolve a zod message key. See helpers/validationMessages.js:
// keeping resolution at the render boundary is what lets schemas stay plain
// module-scope objects while their messages still follow the active language.
export default function CgErrorLabel({ error }) {
  const { t } = useTranslation('common');

  if (typeof error == 'object') {
    return (
      Boolean(error) && (
        <p className="text-red-500 text-sm">
          {resolveValidationMessage(error.message, t) || t('validation.required', 'Required field')}
        </p>
      )
    );
  }
  return error && <p className="text-red-500 text-sm">{resolveValidationMessage(error, t)}</p>;
}
